import { render, staticRenderFns } from "./RegionsFarmersGroups.vue?vue&type=template&id=c16b8570&scoped=true&"
import script from "./RegionsFarmersGroups.vue?vue&type=script&lang=js&"
export * from "./RegionsFarmersGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16b8570",
  null
  
)

export default component.exports